import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const END_DATE_CLASS_NAME = 'react-datepicker__day--end-date';
// ignore the selected start date on the start date picker.
// ignore the selected end date on the end date picker.
export const IGNORE_SELECTED_DATE_CLASS_NAME =
  'react-datepicker__day--ignore-selected-date';

export const Container = styled.div`
  border-left: 1px solid ${theme.colors.border};
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 8px;
`;
